import React from "react";
import { Link } from "react-router-dom";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import BtwAssigneeAvatar from "./btw-assignee-avatar";
import { daysSince, getStatusColor } from "../core/btw-status-colors";

const BtwBoardCard = ({ application, dragging = false }) => {
  const s1 = application.step1 ?? {};
  const naam = `${s1.voorletters ?? ""} ${s1.tussenvoegsel ?? ""} ${s1.achternaam ?? ""}`
    .replace(/\s+/g, " ")
    .trim();
  const ag = application.assignedToAdminId ?? null;
  const ws = application.workflowStatusId ?? null;
  const stillDays = daysSince(application.lastActivityAt ?? application.createdAt);
  const isStuck =
    !application.isArchived && stillDays != null && stillDays >= 7 && ws && !ws.isTerminal;
  const edgeColor = ws ? getStatusColor(ws.color).edge : "bg-line";

  return (
    <div
      className={`group relative overflow-hidden rounded bg-white transition ${
        dragging ? "rotate-1 shadow-overlay ring-2 ring-brand" : "shadow-card hover:bg-sunken"
      }`}
    >
      <span
        className={`absolute left-0 top-0 h-full w-1 ${
          isStuck ? "bg-[#C9372C]" : edgeColor
        }`}
      />
      <Link
        to={`/panel/admin/btw-batterij-overzicht/${application._id}`}
        state={{ from: "board" }}
        className="block p-3 pl-4"
        onClick={(e) => {
          if (dragging) e.preventDefault();
        }}
      >
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0 flex-1">
            <div className="truncate text-sm font-medium text-ink">
              {naam || "Onbekend"}
            </div>
            <div className="truncate text-xs text-ink-subtlest">{s1.email ?? ""}</div>
          </div>
          <BtwAssigneeAvatar user={ag} size="xs" />
        </div>
        <div className="mt-2 flex items-center justify-between text-xs tabular-nums text-ink-subtlest">
          <span>€ {(application.amountInclVat ?? 0).toFixed(2)}</span>
          {stillDays != null ? (
            <span
              className={`${
                isStuck ? "font-semibold text-[#AE2A19]" : "text-ink-disabled"
              }`}
            >
              {stillDays === 0 ? "vandaag" : `${stillDays}d stil`}
            </span>
          ) : null}
        </div>
      </Link>
    </div>
  );
};

export const DraggableBoardCard = ({ application }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: application._id,
    data: { application },
  });
  const style = {
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0 : 1,
  };
  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <BtwBoardCard application={application} />
    </div>
  );
};

export default BtwBoardCard;
